export default __webpack_public_path__ + "static/media/onboarding-head.d942b230.png";